<template>
  <table-layout>
    <template v-slot:title>
      실적파일(엑셀) 업로드 이력
    </template>
    <template v-slot:button>
      <v-btn class="button save" outlined @click="fileUpload">
        파일 업로드
      </v-btn>
    </template>
    <template v-slot:table>
      <v-data-table
        fixed-header
        max-height="65vh"
        :headers="getHeader(headers)"
        :items="data"
        no-data-text="조회된 데이터가 없습니다"
        :loading="loading"
        :items-per-page="-1"
        mobile-breakpoint="md"
      >
        <template v-slot:item.createDate="{ value }">
          <div>{{ setTableDateFormat(value) }}</div>
        </template>
        <template v-slot:item.errorMsg="{ value }">
          <v-tooltip bottom v-model="showErrorMsg">
            <template v-slot:activator="{ on }">
              <div v-on="on" @click="showErrorMsg = !showErrorMsg">{{ overLengthText(value, 20) }}</div>
            </template>
            <span>{{ value }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.delete="{ item }">
          <v-btn class="button delete" outlined @click="deleteUploadFile(item)">
            삭제
          </v-btn>
        </template>
        <template v-slot:item.delYn="{ item }">
          <div class="d-flex justify-center align-center">
            <v-switch
                v-model="item.delYn"
                :true-value="'N'"
                :false-value="'Y'"
                @mousedown.native="savePreviousDelYn(item)"
                @change="changeUploadFileDelYn(item)"
            />
          </div>
        </template>
      </v-data-table>
      <input @input="loadData" class="d-none" :accept="SheetJSFT" type="file" ref="file" />
    </template>
  </table-layout>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import TableMixin from "@/mixin/TableMixin";
import {LOAN_PERFORMANCE_UPLOAD_TABLE} from "@/util/TableHeaders";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "LoanPerformanceUploadTable",
  components: {TableLayout},
  props: ["data", "loading"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      headers: LOAN_PERFORMANCE_UPLOAD_TABLE,
      SheetJSFT: ["xlsx", "xlsb", "xlsm", "xls", "xml", "csv"].map(x => "." + x).join(","),
      showErrorMsg: false,
      previousValue: null
    }
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"})
  },
  methods: {
    fileUpload() {
      this.$refs.file.click();
    },
    async loadData({target: {files}}) {
      let uploadFile = {};
      if (!files || files.length < 1) {
        await this.showAlert({message: "올바른 파일이 아닙니다."});
        return false;
      } else {
        for (const file of Array.from(files)) {
          const base64String = await this.getFileBase64(file);
          const removeFileTypeNm = file.name.replace(/\.[^/.]+$/, '');
          const excelType = "vnd.openxmlformats-officedocument.spreadsheetml.sheet";

          let fileType = file.type.split("/")[1];
          if (fileType === excelType) {
            fileType = "xlsx";
          }
          uploadFile = {
            fileNm: removeFileTypeNm,
            fileType: fileType,
            fileStr: base64String,
            memberId: this.memberId
          };
        }
      }
      await this.showConfirm({
        message: "파일을 업로드하시겠습니까?",
        successCallback: () => {
          this.upload(uploadFile);
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async upload(fileDto) {
      await axiosInstance.post("/admin/performance/upload", fileDto)
          .then(() => {
            this.showAlert({
              message: "업로드가 완료되었습니다.",
              successCallback: () => {
                this.$emit("refresh");
              }
            })
          }).catch((error) => {
            this.showAlert({message: `${error}`});
          })
    },
    getFileBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      })
    },
    savePreviousDelYn(item) {
      this.previousValue = item.delYn;
    },
    changeUploadFileDelYn(item) {
      this.showConfirm({
        message: `업로드 엑셀파일을 ${item.delYn === 'N' ? '사용' : '미사용'} 하시겠습니까?`,
        successCallback: () => {
          this.changeDelYn(item);
        },
        failCallback: () => {
          this.$set(item, 'delYn', this.previousValue);
          return false;
        }
      })
    },
    async changeDelYn(file) {
      await axiosInstance.patch("/admin/performance/file", {}, {
        params: {
          delYn: file.delYn,
          fileId: file.fileId
        }
      }).then(() => {
        this.showAlert({
          message: "수정완료 되었습니다.",
          successCallback: () => {
            this.$emit("refresh");
          }
        })
      })
    },
    deleteUploadFile(item) {
      this.showConfirm({
        message: `${item.fileNm} 파일을 삭제하시겠습니까?`,
        successCallback: () => {
          this.deleteFile(item);
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async deleteFile(file) {
      await axiosInstance.delete("/admin/performance/file", {
        params: {
          fileId: file.fileId
        }
      }).then(() => {
        this.showAlert({
          message: "삭제가 완료되었습니다.",
          successCallback: () => {
            this.$emit("refresh");
          }
        })
      }).catch((error) => {
        this.showAlert({message: `${error}`});
      })
    }
  }
}
</script>